import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';

import { ChangeIndicatedAbbreviatedNumber } from '../../../../../../../src/components/common/number';
import Text from '../../../../../../../src/components/common/text';
import { NO_DATA } from '../../../../../../../src/constants';
import { injectIntl } from 'react-intl';
import styles from './asset-item-data.styles';
function AssetItemDataChange(props) {
  const { value } = props;

  if (value === null || value === undefined) {
    return (
      <div aria-label={props.intl.messages['app.common.nullValue']}>
        <Text>{NO_DATA}</Text>
      </div>
    )
  }

  if (typeof value !== 'number') {
    return null;
  }

  return (
    <ChangeIndicatedAbbreviatedNumber
      renderProps={{ size: 'small' }}
      renderExactAs="currency"
      // maxDigits={30}
      value={value}
      colorStyle={styles.assetItemDataChange }
    />
  );
}

AssetItemDataChange.propTypes = {
  value: PropTypes.number,
};
AssetItemDataChange.contextTypes = {
  intl: PropTypes.object,
};

export default pure(injectIntl(AssetItemDataChange));
